// extracted by mini-css-extract-plugin
export var heroImage = "_dk-1";
export var modal = "_dk-0";